const doc = [({"ko":({"adminLabelCompanyInvoice":({"createdDate":"만든 날짜", "price":"가격", "uniqueId":"송장번호"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;